/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_Lockin_TermInputs */

const en_marketing_faq_lockin_term = /** @type {(inputs: Marketing_Faq_Lockin_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am I locked into Cloudflare?`)
};

const es_marketing_faq_lockin_term = /** @type {(inputs: Marketing_Faq_Lockin_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quedo atado a Cloudflare?`)
};

const fr_marketing_faq_lockin_term = /** @type {(inputs: Marketing_Faq_Lockin_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suis-je enfermé dans Cloudflare ?`)
};

/**
* | output |
* | --- |
* | "Am I locked into Cloudflare?" |
*
* @param {Marketing_Faq_Lockin_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_lockin_term = /** @type {((inputs?: Marketing_Faq_Lockin_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_Lockin_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_lockin_term(inputs)
	if (locale === "es") return es_marketing_faq_lockin_term(inputs)
	return fr_marketing_faq_lockin_term(inputs)
});